import { useTranslation } from 'react-i18next';
import CustomButton from '../../components/CustomButton';
import { useSignOut } from '../../hooks/useSignOut';

/**
 * Shown instead of the whole app once a request was refused with
 * `tenant_archived` (#1379): the account's owner closed it. Never a blank page
 * or a generic error — the user learns what happened, that kolula support can
 * still reactivate it for a while, and can sign out.
 */
const AccountClosedPage = () => {
    const { t } = useTranslation();
    const signOut = useSignOut();

    return (
        <div className={'flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center'}>
            <h1 className={'text-xl font-semibold text-foreground'}>{t('account_closed.title')}</h1>
            <p className={'max-w-md text-sm text-foreground/60'}>{t('account_closed.description')}</p>
            <CustomButton title={t('side_bar.logout')} onClick={signOut} fullWidth={false} />
        </div>
    );
};

export default AccountClosedPage;
